import * as React from 'react';
import styled from 'styled-components';

interface AppleMusicProps {
  className?: string;
}

export const AppleMusic: React.FC<AppleMusicProps> = (props) =>
  <svg
    viewBox="0 0 84.3 20.7"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path d="M35.4 20.1V6.6h-0.1l-5.4 13.5h-2.1L22.4 6.6h-0.1v13.5h-2.5V1.8H23l5.8 14.6h0.1l5.8-14.6H38v18.3L35.4 20.1 35.4 20.1zM52.1 20.1h-2.6v-2.3h-0.1c-0.7 1.6-2.1 2.5-4.1 2.5 -2.9 0-4.6-1.9-4.6-5V6.7h2.7v8.1c0 2 1 3.1 2.8 3.1 2 0 3.1-1.4 3.1-3.5V6.7H52L52.1 20.1 52.1 20.1zM59.5 6.5c3.1 0 5 1.7 5.1 4.2h-2.5c-0.2-1.3-1.1-2.1-2.6-2.1S57 9.3 57 10.4c0 0.8 0.6 1.4 2 1.7l2.1 0.5c2.7 0.6 3.7 1.7 3.7 3.6 0 2.4-2.2 4.1-5.3 4.1 -3.3 0-5.3-1.6-5.5-4.2h2.7c0.2 1.4 1.2 2.1 2.8 2.1s2.6-0.7 2.6-1.8c0-0.9-0.5-1.4-1.9-1.7l-2.1-0.5c-2.5-0.6-3.7-1.8-3.7-3.8C54.4 8.1 56.4 6.5 59.5 6.5zM66.8 3.2c0-0.9 0.7-1.6 1.6-1.6S70 2.3 70 3.2s-0.7 1.6-1.6 1.6S66.8 4.1 66.8 3.2L66.8 3.2zM67 6.7h2.7v13.4H67V6.7zM81.1 11.3c-0.3-1.4-1.3-2.6-3.1-2.6 -2.1 0-3.5 1.8-3.5 4.6 0 2.9 1.4 4.6 3.5 4.6 1.7 0 2.7-0.9 3.1-2.5h2.6c-0.3 2.8-2.5 4.8-5.7 4.8 -3.8 0-6.2-2.6-6.2-6.9 0-4.2 2.4-6.9 6.2-6.9 3.4 0 5.4 2.2 5.7 4.8L81.1 11.3 81.1 11.3zM11.5 3.6C10.8 4.4 9.7 5.1 8.6 5 8.4 3.8 9 2.6 9.6 1.9c0.7-0.9 1.9-1.5 2.9-1.5C12.6 1.5 12.2 2.7 11.5 3.6L11.5 3.6zM12.5 5.2c0.6 0 2.4 0.2 3.6 2C16 7.3 14 8.5 14 11c0 3 2.6 4 2.6 4 0 0.1-0.4 1.4-1.3 2.8 -0.8 1.2-1.7 2.4-3 2.4s-1.7-0.8-3.2-0.8 -2 0.8-3.2 0.8c-1.3 0-2.3-1.3-3.1-2.5 -1.7-2.5-3-7-1.2-10 0.8-1.5 2.4-2.5 4-2.5 1.3 0 2.5 0.9 3.2 0.9C9.5 6.1 10.9 5.1 12.5 5.2L12.5 5.2z"/>
  </svg>

export default styled(AppleMusic)`
  & > path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;